export const europeanCountries = [
  {
    sno: 1,
    countryName: "Albania",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "National ID Number",
    key1regex: "^[A-Za-z0-9]{10}$",
    key2regex: "^[A-Za-z0-9]{10}$",
    key3regex: "^[a-zA-Z0-9]{10}$",
  },
  {
    sno: 2,
    countryName: "Andorra",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "CASS (Caixa Andorrana de Seguretat Social)",
    key1regex: "^[A-Za-z0-9]{8}$",
    key2regex: "^\\d{10}$",
    key3regex: "^\\d{9}$",
  },
  {
    sno: 3,
    countryName: "Armenia",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "National ID Card (Նույնացման քարտ)",
    key1regex: "^\\d{8}$",
    key2regex: "^\\d{8}$",
    key3regex: "^\\d{10}$",
  },
  {
    sno: 4,
    countryName: "Austria",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "Social Security Number (SVNR)",
    key1regex: "^[A-Za-z0-9]{11}$",
    key2regex: "^[A-Za-z0-9]{9}$",
    key3regex: "^\\d{10}$",
  },
  {
    sno: 5,
    countryName: "Azerbaijan",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "National ID Card (Şəxsiyyət vəsiqəsi)",
    key1regex: "^\\d{10}$",
    key2regex: "^.*$",
    key3regex: "^\\d{8}$",
  },
  {
    sno: 6,
    countryName: "Belarus",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "Passport (Internal) Primary ID",
    key1regex: "^\\d{9}$",
    key2regex: "^\\d{9}$",
    key3regex: "^[A-Za-z0-9]{9}$",
  },
  {
    sno: 7,
    countryName: "Belgium",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "eID (Electronic ID Card) National ID",
    key3regex: "^\\d{11}$",
    key1regex: "^[A-Za-z0-9]{12}$",
    key2regex: "^\\d{10}$",
  },
  {
    sno: 8,
    countryName: "Bosnia and Herzegovina",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "National ID (Lična karta/Osobna iskaznica) JBSM",
    key3regex: "^\\d{13}$",
    key1regex: "^\\d{9}$",
    key2regex: "^\\d{7,10}$",
  },
  {
    sno: 9,
    countryName: "Bulgaria",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "Bulgarian ID Card (Лична карта)",
    key3regex: "^\\d{10}$",
    key1regex: "^[A-Za-z0-9]{11,12}$",
    key2regex: "^\\d{9}$",
  },
  {
    sno: 10,
    countryName: "Croatia",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "ID Card (Osobna iskaznica)",
    key3regex: "^\\d{11}$",
    key1regex: "^[A-Za-z0-9]{13}$",
    key2regex: "^\\d{11}$",
  },
  {
    sno: 11,
    countryName: "Cyprus",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "Cypriot ID Card (National ID)",
    key3regex: "^[A-Za-z]{1,2}d{6}$",
    key1regex: "^[A-Za-z0-9]{11}$",
    key2regex: "^[A-Za-z0-9]{8}$",
  },
  {
    sno: 12,
    countryName: "Czech Republic",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "Rodné číslo (Birth Number)",
    key3regex: "^\\d{10}$",
    key1regex: "^[A-Za-z0-9]{10,12}$",
    key2regex: "^\\d{8}$",
  },
  {
    sno: 13,
    countryName: "Denmark",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "CPR Number (Det Centrale Personregister): All IDs (tax, health, etc.)",
    key3regex: "^\\d{10}$",
    key1regex: "^[A-Za-z0-9]{10}$",
    key2regex: "^\\d{8}$",
  },
  {
    sno: 14,
    countryName: "Estonia",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "ID Card (Isikutunnistus): National ID",
    key3regex: "^\\d{11}$",
    key1regex: "^[A-Za-z0-9]{11}$",
    key2regex: "^\\d{8}$",
  },
  {
    sno: 15,
    countryName: "Finland",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "Henkilötunnus (Personal Identity Code): National ID / tax / health",
    key3regex: "^[A-Za-z0-9]{11}$",
    key1regex: "^[A-Za-z0-9]{10}$",
    key2regex: "^\\d{8}$",
  },
  {
    sno: 16,
    countryName: "France",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "Carte Nationale d’Identité (CNI)",
    key3regex: "^\\d{15}$",
    key1regex: "^[A-Za-z0-9]{13}$",
    key2regex: "^\\d{9}$",
  },
  {
    sno: 17,
    countryName: "Georgia",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "ID Card (პირადობის მოწმობა): National ID",
    key3regex: "^\\d{11}$",
    key1regex: "^\\d{9}$",
    key2regex: "^\\d{9}$",
  },
  {
    sno: 18,
    countryName: "Germany",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "Personalausweis (ID Card) National ID",
    key3regex: "^[A-Za-z0-9]{9}$",
    key1regex: "^[A-Za-z0-9]{11}$",
    key2regex: "^[A-Za-z0-9]{8}$",
  },
  {
    sno: 19,
    countryName: "Greece",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "ID Card (Δελτίο Αστυνομικής Ταυτότητας)",
    key3regex: "^[A-Za-z]{1,2}d{6}$",
    key1regex: "^[A-Za-z0-9]{11}$",
    key2regex: "^\\d{9}$",
  },
  {
    sno: 20,
    countryName: "Hungary",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "Personal ID Card (Személyi igazolvány)	National ID",
    key3regex: "^[A-Za-z0-9]{8}$",
    key1regex: "^[A-Za-z0-9]{10}$",
    key2regex: "^\\d+-\\d+$",
  },
  {
    sno: 21,
    countryName: "Iceland",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "Kennitala (National ID Number) All services: tax, ID, social",
    key3regex: "^\\d{10}$",
    key1regex: "^\\d{10}$",
    key2regex: "^\\d{10}$",
    key4regex: "^\\{11}$",
  },
  {
    sno: 22,
    countryName: "Ireland",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "PPS Number (Personal Public Service Number)	Tax, healthcare, ID",
    key3regex: "^[A-Za-z0-9]{8,9}$",
    key1regex: "^[A-Za-z0-9]{10}$",
    key2regex: "^[A-Za-z0-9]{8}$",
  },
  {
    sno: 23,
    countryName: "Italy",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "Carta d'Identità (ID Card)",
    key1regex: "^[A-Za-z0-9]{13}$",
    key2regex: "^[A-Za-z0-9]{9}$",
    key3regex: "^[A-Za-z0-9]{9}$",
  },
  {
    sno: 24,
    countryName: "Kazakhstan",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "D Card (Жеке куәлік) National ID IIN (Individual Identification Number)",
    key3regex: "^\\d{12}$",
    key1regex: "^\\d{12}$",
    key2regex: "^\\d{12}$",
  },
  {
    sno: 25,
    countryName: "Kosovo",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "Personal Number (Numri Personal)",
    key3regex: "^\\d{10}$",
    key1regex: "^\\d{9}$",
    key2regex: "^\\d{9}$",
    key4regex: "/^[A-Za-z0-9]{10}$/",
  },
  {
    sno: 26,
    countryName: "Latvia",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "Personal code (Personas kods)",
    key3regex: "^\\d{11}$",
    key1regex: "^[A-Za-z0-9]{13}$",
    key2regex: "^\\d{11}$",
  },
  {
    sno: 27,
    countryName: "Liechtenstein",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "National Identity Card Number",
    key3regex: "^[A-Za-z]{1,2}d{8}$",
    key1regex: "^[A-Za-z0-9]{16}$",
    key2regex: "^[A-Za-z0-9]{13}$",
  },
  {
    sno: 28,
    countryName: "Lithuania",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "Personal code (Asmens kodas)",
    key3regex: "^\\d{11}$",
    key1regex: "^[A-Za-z0-9]{11,14}$",
    key2regex: "^\\d{9}$",
  },
  {
    sno: 29,
    countryName: "Luxembourg",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "Matricule Number: Parsonal ID, Social security number (CNS)",
    key3regex: "^\\d{13}$",
    key1regex: "^[A-Za-z0-9]{10}$",
    key2regex: "^[A-Za-z0-9]{7}$",
  },
  {
    sno: 30,
    countryName: "Malta",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "National Identification Number: ID number",
    key3regex: "^[A-Za-z0-9]{8}$",
    key1regex: "^[A-Za-z0-9]{10}$",
    key2regex: "^[A-Za-z0-9]{6}$",
  },
  {
    sno: 31,
    countryName: "Moldova",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "Identity Card (Buletin de identitate)",
    key3regex: "^\\d{13}$",
    key1regex: "^\\d{7}$",
    key2regex: "^\\d{13}$",
  },
  {
    sno: 32,
    countryName: "Monaco",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "ID Card (Carte d’identité Monégasque)",
    key3regex: "^[A-Za-z0-9]{9}$",
    key1regex: "^[A-Za-z0-9]{13}$",
    key2regex: "^[A-Za-z0-9]{8}$",
  },
  {
    sno: 33,
    countryName: "Montenegro",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "ID Card (Lična karta) JMBG",
    key3regex: "^\\d{13}$",
    key1regex: "^\\d{8}$",
    key2regex: "^\\d{8}$",
  },
  {
    sno: 34,
    countryName: "Netherlands",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "National identity card number:  BSN Number",
    key3regex: "^[A-Za-z0-9]{9}$",
    key1regex: "^[A-Za-z0-9]{14}$",
    key2regex: "^\\d{8}$",
  },
  {
    sno: 35,
    countryName: "North Macedonia",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "ID Card (Лична карта / Letenka)",
    key3regex: "^\\d{13}$",
    key1regex: "^[A-Za-z0-9]{15}$",
    key2regex: "^\\d{13}$",
  },
  {
    sno: 36,
    countryName: "Norway",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "National id (Foedselsnummer)",
    key3regex: "^\\d{11}$",
    key1regex: "^[A-Za-z0-9]{14}$",
    key2regex: "^\\d{9}$",
  },
  {
    sno: 37,
    countryName: "Poland",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "National Identification Number (PESEL)",
    key3regex: "^\\d{11}$",
    key1regex: "^[A-Za-z0-9]{12}$",
    key2regex: "^\\d{9}$",
  },
  {
    sno: 38,
    countryName: "Portugal",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "NISS (Social Security Number)",
    key3regex: "^\\d{11}$",
    key1regex: "^[A-Za-z0-9]{11}$",
    key2regex: "^\\d{9}$",
  },
  {
    sno: 39,
    countryName: "Romania",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "National Identification Number (Cod Numeric Personal) CNP",
    key3regex: "^\\d{13}$",
    key1regex: "^[A-Za-z0-9]{12}$",
    key2regex: "^(\\d{8}|[A-Za-z0-9]{10})$",
  },
  {
    sno: 40,
    countryName: "San Marino",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "ID Card (Carta d’identità)",
    key3regex: "^[A-Za-z0-9]{6,8}$",
    key1regex: "^[A-Za-z0-9]{7}$",
    key2regex: "^[A-Za-z0-9]{7}$",
  },
  {
    sno: 41,
    countryName: "Serbia",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "JMBG (Unique Master Citizen Number)",
    key3regex: "^\\d{13}$",
    key1regex: "^\\d{9}$",
    key2regex: "^\\d{8}$",
  },
  {
    sno: 42,
    countryName: "Slovakia",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "Personal number (Rodné číslo)",
    key3regex: "^\\d{10}$",
    key1regex: "^[A-Za-z0-9]{12}$",
    key2regex: "^\\d{8}$",
  },
  {
    sno: 43,
    countryName: "Slovenia",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "Personal Identification Number (EMŠO: Enotna Matična Številka Občana)",
    key3regex: "^\\d{13}$",
    key1regex: "^[A-Za-z0-9]{10}$",
    key2regex: "^\\d{8}$",
  },
  {
    sno: 44,
    countryName: "Spain",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "DNI (Documento Nacional de Identidad)",
    key3regex: "^[A-Za-z0-9]{9}$",
    key1regex: "^[A-Za-z0-9]{11}$",
    key2regex: "^[A-Za-z0-9]{9}$",
  },
  {
    sno: 45,
    countryName: "Sweden",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "Personnummer (Personal ID Number)",
    key3regex: "^\\d{12}$",
    key1regex: "^[A-Za-z0-9]{14}$",
    key2regex: "^\\d{10}$",
  },
  {
    sno: 46,
    countryName: "Switzerland",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "AHV Number (Social Security Number)",
    key3regex: "^\\d{13}$",
    key1regex: "^[A-Za-z0-9]{16}$",
    key2regex: "^[A-Za-z0-9]{12}$",
  },
  {
    sno: 47,
    countryName: "Turkey",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "T.C. Kimlik No (Turkish Identity Number)",
    key3regex: "^\\d{11}$",
    key1regex: "^\\d{10}$",
    key2regex: "^(\\d{10}|\\d{16})$",
  },
  {
    sno: 48,
    countryName: "United Kingdom",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "National Insurance Number (NINo)",
    key3regex: "^[A-Za-z]{2}[0-9]{6}[A-Za-z]{1}$",
    key1regex: "^[A-Za-z0-9]{11}$",
    key2regex: "^\\d{8}$",
  },
  {
    sno: 49,
    countryName: "Bangladesh",
    key1: "VAT Registration Number",
    key2: "Certificate of Incorporation",
    key3: "National Identity Card (NID) ",
    key3regex:"^(\\d{10}|\\d{17})$",
    key1regex: "^\\d{9}-\\d{4}$", // Example: 123456789-0123
    key2regex: "^[A-Za-z0-9]{10}$",
    key4regex: "^\\d{13}$",
  },
  {
    sno: 50,
    countryName: "Sri Lanka",
    key1: "VAT Registration Number",
    key2: "Certificate of Incorporation",
    key3: "National Identity Card (NIC)",
    key3regex: "^(\\d{9}[VX]|\\d{12})$",
    key1regex: "^\\d{12}$",
    key2regex: "^[A-Za-z0-9]{8}$",
    key4regex: "^[A-Za-z0-9]{8}$",
  },
  {
    sno: 51,
    countryName: "Nepal",
    key1: "VAT Registration Number",
    key2: "Certificate of Incorporation",
    key3: "National ID (Smart Card)",
    key3regex: "^\\d{13}$",
    key1regex: "^\\d{9}$",
    key2regex: "^[A-Za-z0-9]{13}$",
    key4regex:"^(\\d{10}|\\d{12})$",
  },
  {
    sno: 52,
    countryName: "Bhutan",
    key1: "VAT Registration Number",
    key2: "Certificate of Incorporation",
    key3: "Citizenship Identity Card (CID) ",
    key3regex: "^\\d{11}$",
    key1regex: "^[A-Za-z0-9]{8}$",
    key2regex: "^[A-Za-z0-9]{16}$",
    key4regex: "^\\d{8}$",
  },
  {
    sno: 53,
    countryName: "Singapore",
    // key1: "Goods and Services Tax (GST) Registration Number",
    key2: "Unique Entity Number (UEN)",
    key3: "National Registration Identity Card (NRIC)",
    key3regex: "^[A-Za-z0-9]{9}$",
    key1regex: "^\\d{10}$",
    key2regex: "^[A-Za-z0-9]{10}$",
    key1: "GST Number",
  },
  {
    sno: 54,
    countryName: "Malaysia",
    key1: "Sales and Service Tax (SST)",
    key2: "Company Registration Number",
    key3: "MyKad (National ID Card)",
    key3regex: "^\\d{12}$",
    key1regex: "^[A-Za-z0-9]{15}$",
    key2regex: "^[A-Za-z0-9]{12}$",
  },
  {
    sno: 55,
    countryName: "Indonesia",
    key1: "Taxpayer Identification Number (NPWP)",
    key2: "Company Registration Number (NIB)",
    key3: "National ID (KTP - Kartu Tanda Penduduk)",
    key3regex: "^\\d{16}$",
    key1regex: "^\\d{15}$",
    key2regex: "^\\d{13}$",
  },
  {
    sno: 56,
    countryName: "Taiwan",
    key1: "VAT Registration Number",
    key2: "Unified Business Number (UBN)",
    key3: "National ID",
    key3regex: "^[A-Za-z0-9]{10}$",
    key1regex: "^\\d{8}$",
    key2regex: "^\\d{8}$",
  },
  {
    sno: 57,
    countryName: "Philippines",
    key2: "Certificate of Incorporation",
    key1: "Tax Identification Number (TIN)",
    key3: "PhilSys ID (Philippine National ID)",
    key3regex: "^\\d{12}$",
    key1regex: "^(CS|CN|OPC|LLP|FN)[0-9]{4}-?[0-9]{5}$",
    key2regex: "^\\d{12}$",
  },
  {
    sno: 58,
    countryName: "Brunei Darussalam",
    key1: "Tax Identification Number (TIN)",
    key2: "Company Registration Number",
    key3: "National Registration Identity Card (NRIC)",
    key3regex: "^\\d{8}$",
    key1regex: "^\\d{10}$",
    key2regex: "^(RC|BN|RFC)[0-9]{4}[0-9]{5}$",
  },
  {
    sno: 59,
    countryName: "Hong Kong",
    key1: "Tax Identification Number (TIN)",
    key2: "Company Registration Number",
    key3: "HKID",
    key3regex: "^[A-Za-z0-9]{8,9}$",
    key1regex: "^\\d{8}$",
    key2regex: "^\\d{7}$",
    key4regex: "^\\d{8}$",
  },
  {
    sno: 60,
    countryName: "Vietnam",
    key1: "VAT Registration Number",
    key2: "Company Registration Number",
    key3: "National ID (CCCD - Căn cước công dân)",
    key3regex: "^\\d{12}$",
    key1regex: "^\\d{10}$",
    key2regex: "^\\d{10}$",
  },
  {
    sno: 61,
    countryName: "Thailand",
    key1: "VAT/TRN Registration Number",
    key2: "Company Registration Number",
    key3: "",
    key3regex: "^\\d{10}$",
    key1regex: "^\\d{13}$",
    key2regex: "^\\d{13}$",
  },
  {
    sno: 62,
    countryName: "New Zealand",
    // key1: "Goods and Services Tax (GST) Registration Number",
    key2: "Certificate of Incorporation",
    key3: "",
    key3regex: "^\\d{8}$",
    key1regex: "^\\d{9}$",
    key2regex: "^\\d{13}$",
    key1: "GST Number",
  },
  {
    sno: 63,
    countryName: "Australia",
    // key1: "Goods and Services Tax (GST) Registration Number",
    key2: "Australian Business Number (ABN)",
    key3: "Medicare Number",
    key3regex: "^\\d{8,10}$",
    key1regex: "^\\d{11}$",
    key2regex: "^\\d{11}$",
    key4regex: "^\\d{10}$",
    key1: "GST Number",
  },
  {
    sno: 64,
    countryName: "United Arab Emirates",
    key1: "VAT/TRN Registration Number",
    key2: "Emirates Id",
    key3: "Emirates ID(Main national ID)",
    key3regex: "^\\d{15}$",
    key1regex: "^\\d{15}$",
    key2regex: "^[A-Za-z0-9]{15}$",
    key4regex: "^\\d{12}$",
  },
  {
    sno: 65,
    countryName: "Oman",
    key1: "Tax Identification Number (TIN)",
    key2: "Commercial Registration Number (CRN)",
    key3: "Civil ID / National ID",
    key3regex: "^\\d{9}$",
    key1regex: "^\\d{10}$",
    key2regex: "^\\d{1,10}$",
    key4regex: "^\\d{6,8}$",
  },
  {
    sno: 66,
    countryName: "Saudi Arabia",
    key1: "Tax Identification Number (TIN)",
    key2: "Commercial Registration Number (CRN)",
    key3: "National ID (Citizens)",
    key3regex: "^\\d{10}$",
    key1regex: "^\\d{15}$",
    key2regex: "^\\d{10}$",
  },
  {
    sno: 67,
    countryName: "Qatar",
    key1: "VAT Registration Number",
    key2: "Commercial Registration Number (CRN)",
    key3: "Qatar ID (QID)",
    key3regex: "^\\d{11}$",
    key1regex: "^\\d{15}$",
    key2regex: "^\\d{10}$",
  },
  {
    sno: 69,
    countryName: "Kuwait",
    key1: "Tax Identification Number (TIN)",
    key2: "Commercial Registration Number (CRN)",
    key3: "Civil ID",
    key3regex: "^\\d{12}$",
    key1regex: "^\\d{9}$",
    key2regex: "^\\d{7}$",
  },
  {
    sno: 70,
    countryName: "Bahrain",
    key1: "Tax Identification Number (TIN)",
    key2: "Commercial Registration Number (CRN)",
    key3: "CPR (Central Population Registry) Number / Smart Card",
    key3regex: "^\\d{9}$",
    key1regex: "^\\d{9}$",
    key2regex: "^\\d{7}$",
  },
  {
    sno: 71,
    countryName: "Jordan",
    key1: "Tax Identification Number (TIN)",
    key2: "Commercial Registration Number (CRN)",
    key3: "National ID",
    key3regex: "^\\d{10}$",
    key1regex: "^\\d{9}$",
    key2regex: "^\\d{7}$",
  },
  {
    sno: 72,
    countryName: "Egypt",
    key1: "Tax Identification Number (TIN)",
    key2: "Commercial Registration Number (CRN)",
    key3: "National ID",
    key3regex: "^\\d{14}$",
    key1regex: "^\\d{9}(\\d{5})?$",
    key2regex: "^\\d{7}$",
  },
  {
    sno: 73,
    countryName: "Israel",
    key1: "Tax Identification Number (TIN)",
    key2: "Commercial Registration Number (CRN)",
    key3: "Teudat Zehut (National ID)",
    key3regex: "^\\d{9}$",
    key1regex: "^\\d{9}$",
    key2regex: "^\\d{9}$",
  },

  {
    sno: 76,
    countryName: "Ukraine",
    key1: "Tax Identification Number (TIN)",
    key2: "Certificate of Incorporation",
    key3: "National ID Card (Newer biometric format)",
    key3regex: "^[A-Za-z0-9]{9}$",
    key1regex: "^\\d{10}$",
    key2regex: "^\\d{8,10}$",
    key4regex: "^\\d{9}$",
  },
  {
    sno: 77,
    countryName: "Russia",
    key1: "Tax Identification Number (TIN)",
    key2: "Certificate of Incorporation",
    key3: "Internal Passport/Main national ID",
    key3regex: "^\\d{10}$",
    key1regex: "^\\d{10,12}$",
    key2regex: "^\\d{13}$",
    key4regex: "^[A-Za-z0-9]{10}$",
  },
  {
    sno: 78,
    countryName: "United States",
    key1: "Sales Tax License ",
    key2: "Certificate of Incorporation",
    key3: "Social Security Number (SSN)",
    key3regex: "^\\d{9}$",
    key1regex: "^\\d{9}$",
    key2regex: "^[A-Za-z0-9]{6,12}$",
    key4regex: "^\\{13}$",
  },
  {
    sno: 79,
    countryName: "Canada",
    key2: "Business Number (BN)",
    key3: "Social Insurance Number (SIN)",
    key3regex: "^\\d{9}$",
    key1regex: "^[A-Za-z0-9]{15}$",
    key2regex: "^\\d{9,12}$",
    key1: "GST Number/ HST Number",
    key4regex: "^[A-Za-z0-9]{5,12}$",
  },
  {
    sno: 80,
    countryName: "India",
    key1: "GST Number",
    key2: "Business Number (BN)",
    key3: "Aadhar Number",
    key3regex: "^\\d{12}$",
    key1regex: "^[A-Za-z0-9]{15}$",
    key2regex: "^\\d{9,12}$",
    key4regex: "^[A-Z]{2}[0-9]{2}[0-9]{11}$",
  },
  {
    sno: 81,
    countryName: "Tambo",
    key1: "GST Number",
    key2: "Business Number (BN)",
    key3: "National ID",
    key3regex: "^\\d{12}$",
    key1regex: "^[A-Za-z0-9]{15}$",
    key2regex: "^\\d{9,12}$",
  },
];
